import React from "react";
import "./ceramic-coating.css";
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";
export default function CeramicCoating() {
  return (
    <>
    <Helmet>
      <title>Best 9H Ceramic Coating Service in Palwal</title>
      <meta
        name="description"
        content="Looking for the best 9H ceramic coating in Palwal? AutoCare offers professional ceramic coating services that provide long-lasting shine, scratch resistance, and paint protection."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/ceramic-coating"
      />
      </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Best 9H Ceramic Coating Service in Palwal</h1>

          <p>
            Looking for the <strong>best 9H ceramic coating</strong> to protect your car?
            At <strong>AutoCare</strong>, we provide
            <span className="highlight"> professional ceramic coating services</span>
            that deliver long-lasting shine, protection, and durability.
            Trusted <strong>Auto Care in Palwal</strong> and recognized as one of the
            <span className="highlight"> best car care & repair shops</span> in the area.
          </p>

          <h2>What is 9H Ceramic Coating?</h2>
          <p>
            9H ceramic coating is an advanced <span className="highlight">
            car paint protection</span> technology that creates a hard,
            glossy, and hydrophobic layer over your car’s paint.
            It protects against scratches, UV rays, dirt, and chemical stains.
          </p>

          <h2>Benefits of 9H Ceramic Coating</h2>
          <ul>
            <li>Deep glossy finish & showroom shine</li>
            <li>Scratch resistance & paint protection</li>
            <li>UV & oxidation protection</li>
            <li>Water-repellent & easy cleaning</li>
            <li>Increases car resale value</li>
          </ul>

          <h2>Why AutoCare is the Best Choice for Ceramic Coating</h2>
          <ul>
            <li>One of the <span className="highlight">best ceramic coating shops in Palwal</span></li>
            <li>Certified technicians & premium products</li>
            <li>Long-lasting coating with warranty options</li>
            <li>Affordable pricing with transparent process</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair & detailing</li>
          </ul>

          <h2>Book 9H Ceramic Coating with AutoCare</h2>
          <p>
            Searching for the <span className="highlight">best ceramic coating near me</span>?
            Choose <strong>AutoCare</strong> for expert application, premium finish,
            and long-term protection for your car.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book 9H Ceramic Coating
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/ceramicCoating.webp"
            alt="Best 9H Ceramic Coating Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
